import React from "react";
import { HiOutlineTrash } from "react-icons/hi";
import _ from "lodash";
import { InputContainer } from "../../../../common/components/form/input/containers/input.container";


export default function OBNDBNBizKeyInfoComponent({
  keys,
  onFormItemChange,
  deleteKeys,
}: any) {
  return (
    <div className="h-[500px] overflow-auto w-full bg-white p-6 rounded-xl shadow-md">
      <table className="w-full text-sm border-collapse">
        <thead className="sticky top-0 bg-gray-100 text-gray-700 z-10 shadow-sm">
          <tr className="text-left h-12">
            <th className="px-6 py-3 border-r">SIGNING_PVT_KEY</th>
            <th className="px-6 py-3 border-r">SIGNING_PUB_KEY</th>
            <th className="px-6 py-3 border-r">ENCRYPTION_PVT_KEY</th>
            <th className="px-6 py-3 border-r">ENCRYPTION_PUB_KEY</th>
            <th className="px-6 py-3">Action</th>
          </tr>
        </thead>
        <tbody>
          {_.map(keys, (cardValue: any, index: any) => (
            <tr
              key={index}
              className="h-16 even:bg-gray-50 odd:bg-white hover:bg-gray-100 transition-colors"
            >
              <td className="px-6 py-3">
                <InputContainer
                  isDisabled
                  name="signing_pvt_key"
                  onValueChange={(event: any) =>
                    onFormItemChange({
                      value: event.target.value,
                      field: "signing_pvt_key",
                      idx: index,
                    })
                  }
                  type="text"
                  value={cardValue.signing_pvt_key}
                />
              </td>
              <td className="px-6 py-3">
                <InputContainer
                  isDisabled
                  name="signing_pub_key"
                  onValueChange={(event: any) =>
                    onFormItemChange({
                      value: event.target.value,
                      field: "signing_pub_key",
                      idx: index,
                    })
                  }
                  type="text"
                  value={cardValue.signing_pub_key}
                />
              </td>
              <td className="px-6 py-3">
                <InputContainer
                  isDisabled
                  name="encryption_pvt_key"
                  onValueChange={(event: any) =>
                    onFormItemChange({
                      value: event.target.value,
                      field: "encryption_pvt_key",
                      idx: index,
                    })
                  }
                  type="text"
                  value={cardValue.encryption_pvt_key}
                />
              </td>
              <td className="px-6 py-3">
                <InputContainer
                  isDisabled
                  name="encryption_pub_key"
                  onValueChange={(event: any) =>
                    onFormItemChange({
                      value: event.target.value,
                      field: "encryption_pub_key",
                      idx: index,
                    })
                  }
                  type="text"
                  value={cardValue.encryption_pub_key}
                />
              </td>
              <td className="px-6 py-3">
                <button
                  className="text-red-500 hover:text-red-700 p-2 rounded-full hover:bg-red-50 transition"
                  onClick={async () => deleteKeys(cardValue, index)}
                >
                  <HiOutlineTrash className="w-5 h-5" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
